import {localization} from "@/common/lang/localization";

let formulaLocales = ["en", "de"];
let defaultLocale = "en";
let formulaTemplate = "/vue/pdf/formula/formula_sales_price_calculation_:locale.pdf";

const sellPriceFormula = {
	fileUrlForCurrentLocale: function() {
		let locale = localization.currentLocale();
		if (!formulaLocales.includes(locale)) {
			locale = defaultLocale;
		}

		return formulaTemplate.replace(":locale", locale);
	}
}

export {
	sellPriceFormula
}